import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Geo } from '../../store/commonTypes'

import './geoUserInfoLine.sass'
import moment from 'moment-mini'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import { GeoState } from '../../store/geo/geoTypings'
import { roundingDistance } from '../../utils/geoUtils'

interface Props {
    user: Geo
}

const GeoUserInfoLine: React.FunctionComponent<Props> = ({ user }: Props) => {
    const [t] = useTranslation()
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const member = useSelector((state: RootState) => state.member.user)
    const { filters } = useSelector<RootState, GeoState>((state) => state.geo)

    return (
        <div className="userInfo_geo">
            <Link to={user.profile} target="__blank" className={'avatarPointer'}>
                <div className="imgWrapper">
                    <img src={user.avatar} alt=" "></img>
                </div>
                <div>
                    <span className={`gender gender_${user.gender}`}>
                        <p>{user.nick}</p>{' '}
                    </span>
                    <p>{user.age ? user.age + t('years') : ''}</p>
                </div>
            </Link>
            <div className="onlineBlock">
                <div className={user.online ? 'onlineCircle' : 'offlineCircle'}></div>
                {user.online
                    ? t('Online')
                    : user.last_seen
                    ? `${moment(Number(new Date()) - user.last_seen * 1000).format(t('geo time format'))}`
                    : t('Offline')}
            </div>
            <div className={'isUserSharedLocation'}>
                {user.lat ? (
                    <img className={'markerInList'} src={require('./../../assets/ic-map-marker.svg')} />
                ) : (
                    <></>
                )}
            </div>
            <div className="distanceInfo">
                {!member || user.id != member.id ? (
                    <p>
                        {isNaN(Number(user.distance))
                            ? user.distance
                            : Number(user.distance) >= 1
                            ? roundingDistance(Number(user.distance)) + t('km')
                            : roundingDistance(Number(user.distance)) + t('m')}{' '}
                        {user.exact_loc == 1 && loggedIn && filters && filters.shareMyLocation === 1
                            ? t('exactly')
                            : Number(user.distance) >= 1
                            ? t('approximately')
                            : ''}
                    </p>
                ) : (
                    <p>{t('Your location')}</p>
                )}
            </div>
            <div className="message">{user.message}</div>
        </div>
    )
}

export default GeoUserInfoLine
